import * as THREE from "three";
import { lerp } from "./utils";

global.THREE = THREE;
const createGeometry = require("three-bmfont-text");

const font = require("./static/Pilowlava_Regular.json");
//const GlyphURL = require("./static/Pilowlava_Regular.png");
//const font = require("./static/Roboto-msdf.json");
//const GlyphURL = require("./static/Roboto-msdf.png");

const MSDFShader = require("three-bmfont-text/shaders/msdf");

const fontFile = require("./static/MADE Bon Voyage Regular PERSONAL USE.fnt");
const GlyphURL = require("./static/MADE Bon Voyage Regular PERSONAL USE_0.png");
const loadFont = require("load-bmfont");

export const loadTextAssets = (assets, loader) => {
  assets.font = font;
  loader.begin("glyphs");
  var glyphsLoader = new THREE.TextureLoader();
  glyphsLoader.crossOrigin = "";
  glyphsLoader.load(GlyphURL, glyphs => {
    assets.glyphs = glyphs;
    loader.end("glyphs");
  });
};

export const createTextMaterial = (glyphs, options = {}) => {
  const mdsf = MSDFShader({
    transparent: true,
    side: THREE.DoubleSide,
    map: glyphs,
    color: "rgb(0,0,0)",
    negate: false,
    ...options
  });
  const material = new THREE.RawShaderMaterial({ ...mdsf });
  return material;
};

export class Text {
  constructor(sceneManager, text, pos, scl) {
    this.sceneManager = sceneManager;
    this.glyphs = null;
    this.font = font;
    this.text = text;
    this.pos = pos;
    this.scl = scl;
    this.font1 = null;

    this.baseScale = 1;
    this.scaleY = 1;
    this.scaleX = 1;

    this.scaleMultX = 1;
    this.scaleMultY = 1;

    this.mesh = null;
  }
  load(loader) {
    loader.begin("glyphs");
    var glyphsLoader = new THREE.TextureLoader();
    glyphsLoader.crossOrigin = "";
    glyphsLoader.load(GlyphURL, glyphs => {
      this.glyphs = glyphs;
      loader.end("glyphs");
    });
  }
  init() {
    const { width, height } = this.sceneManager.getViewSize();
    const planeMetrics = this.getPlaneMetrics(
      width,
      height,
      window.innerWidth,
      window.innerHeight
    );

    // const geometry = createGeometry({
    //   font: this.font,
    //   align: "center",
    //   text: this.text,
    // });

    loadFont(fontFile, (err, font) => {
      this.fontGeometry = createGeometry({
        font,
        text: this.text
      });
      const material = createTextMaterial(this.glyphs);
      const mesh = new THREE.Mesh(this.fontGeometry, material);
      //const mesh = new THREE.Mesh(geometry, material);
      this.mesh = mesh;
      this.resizeText(true);
      this.sceneManager.scene.add(mesh);

      let translateToLeft = -width / 2 + planeMetrics.planeWidth / 2;
      let x = translateToLeft + planeMetrics.x;
      let space = planeMetrics.space;
    });


    // const material = createTextMaterial(this.glyphs);
    // const mesh = new THREE.Mesh(geometry, material);
    // this.mesh = mesh;
    // this.resizeText(true);
    // this.sceneManager.scene.add(mesh);

    // let translateToLeft = -width / 2 + planeMetrics.planeWidth / 2;
    // let x = translateToLeft + planeMetrics.x;
    // let space = planeMetrics.space;
    //this.mesh.position.y = height / 5 / 1.5;//10; //x + 0 * space;
    //this.mesh.scale.set(0.,0.1,0);
  }
  updateText(text) {
    if (text === this.text) return;
    this.text = text;
    // const geometry = createGeometry({
    //   font: this.font,
    //   align: "center",
    //   text
    // });

    loadFont(fontFile, (err, font) => {
      this.fontGeometry = createGeometry({
        font,
        text: this.text
      });
      this.mesh.geometry = this.fontGeometry;
      this.mesh.geometry.needsUpdate = true;
      let multX = 1;
      let multY = 1;

      this.setScale(
        this.baseScale * this.scaleMultX,
        this.baseScale * this.scaleMultY
      );

      this.resizeText();
    });

    // this.mesh.geometry = geometry;
    // this.mesh.geometry.needsUpdate = true;
    // let multX = 1;
    // let multY = 1;

    // this.setScale(
    //   this.baseScale * this.scaleMultX,
    //   this.baseScale * this.scaleMultY
    // );

    // this.resizeText();
  }
  update() {
    let scaleXChange = lerp(this.scaleX, this.baseScale, 0.1, 0.00001);
    let scaleYChange = lerp(this.scaleY, this.baseScale, 0.1, 0.00001);
    if (scaleXChange !== 0 || scaleYChange !== 0) {
      this.setScale(this.scaleX + scaleXChange, this.scaleY + scaleYChange);
    }
  }


  getPlaneMetrics(viewWidth, viewHeight, width, height) {
    const planeWidth = viewWidth / 4.5;
    if (width < 800) {
      return {
        planeWidth: viewWidth / 2,
        planeHeight: viewHeight * 0.8,
        x: 0,
        // Calculate the resting(empty) space and divided by number of planes
        space: viewWidth / 2
      };
    }
    return {
      planeWidth,
      planeHeight: viewHeight * 0.8,
      x: viewHeight / 5 / 1.5,
      // Calculate the resting(empty) space and divided by number of planes
      space: (viewWidth - (viewWidth / 5 / 1.5) * 2 - planeWidth) / 2
    };
  }


  resizeText(force = false) {
    let scale = 0.1;
    //let scaleMultX = 1.3;
    //let scaleMultY = 1.05;
    let scaleMultX = 1.3;
    let scaleMultY = 1.05;

    if (window.innerWidth >= 800) {
      scaleMultX = 1.3;
      scaleMultY = 1.05;
      scale = 0.1;
    }
    if (window.innerWidth >= 1070) {
      scaleMultX = 1.3;
      scaleMultY = 1.05;
      scale = 0.15;
    }
    if (window.innerWidth >= 1200) {
      scaleMultX = 1.3;
      scaleMultY = 1.05;
      scale = 0.2;
    }

    // console.log(window.innerWidth);
    // console.log(scale);
    scale = scale * this.scl; // to do 

    this.scaleMultX = scaleMultX;
    this.scaleMultY = scaleMultY;
    this.baseScale = scale;
    if (force) {
      this.setScale(scale, scale);
    }
  }
  setScale(scaleX, scaleY) {
    const mesh = this.mesh;
    const layout = mesh.geometry.layout;
    this.scaleX = scaleX;
    this.scaleY = scaleY;
    mesh.scale.x = scaleX;
    mesh.scale.y = -scaleY;
    // console.log(scaleX);
    // console.log(scaleY);
    // console.log(layout.width);
    // console.log(layout.xHeight);
    // console.log((-layout.xHeight / 2 + this.pos) * scaleY);
    mesh.position.x = (-layout.width / 2) * scaleX;
    mesh.position.y = (-layout.xHeight / 2 + this.pos) * scaleY;
  }
  onResize(width, height) {
    this.resizeText(true);
  }
}
